package gr.tech.pdfgenerator.models.pdf

import kotlinx.serialization.Serializable

@Serializable
data class PdfDTO(
    var id: Int? = null,
    var projectId: Int? = null,
    var projectType: Int? = null,
    var status: Short? = null,
    var filePath: String? = null,
    var createdAt: String? = null,
    var createdBy: String? = null,
    var modifiedAt: String? = null,
    var fileName: String? = null,
)